
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      imageSwiperOptions: {
        slidesPerView: 'auto',
        speed: 500,
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
          },

          1024: {
            slidesPerView: 'auto',
          },
        },

        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
      },
    }
  },
}
